import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import FooterComp from "../component/FooterComp";
import NavbarComp from "../component/NavbarComp";
import RegisterFormComp from "../component/registerFormComp";
import SakuraEffectComp from "../component/SakuraEffectComp";

const RegisterPages = () => {
  useEffect(() => {
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init("1610568986009768");
        ReactPixel.track("AddToCart");
      });
  }, []);
  return (
    <>
      {/* <NavbarComp></NavbarComp> */}
      <div></div>
      <Container>
        <Row style={{ overflow: "hidden" }}>
          <Col md={7} sm={12} xs={{ order: 2 }} >
            <div style={{ width: "100%", position: "fixed" }}>
              <SakuraEffectComp></SakuraEffectComp>
              {/* <img
                src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777422372132-idinvitebookdevices-1.png"
                className="img-fluid"
                style={{ marginTop: "50px", marginBottom: "100px" }}
              /> */}
            </div>
          </Col>

          <Col md={5} sm={12} xs={{ order: 1 }} sm={{ order: 1 }}>
            <div className="mt-5 mb-4">
              <RegisterFormComp></RegisterFormComp>
            </div>
          </Col>
        </Row>
      </Container>
      <FooterComp></FooterComp>
    </>
  );
};

export default RegisterPages;
